// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import landingPage from './landingPage';

landingPage(i18n);
